<template>
  <v-container>
    <div class="questionnaires-analytics">
      <v-row class="my-2">
        <v-col>
          <h2 class="text-no-wrap">
            オンライン相談：アンケート集計
          </h2>
        </v-col>
        <v-col class="pl-0 d-flex justify-end align-center">
          <div class="picker-align-right">
            <month-picker
              v-model:selectedDate="selectedDate"
              @on-month-changed="saveSelectedDate"
              />
          </div>
        </v-col>
      </v-row>
      <template v-if="ncQuestionnaireCount && acQuestionnaireCount && daQuestionnaireCount">
        <div class="mb-5">
          <h4>
            ■夜間相談利用後アンケート／また利用したいと思うか
          </h4>
          <use-service-again-analytics
            v-model:useServiceAgainProp="ncQuestionnaireCount.useServiceAgain"
          />
        </div>
        <div class="mb-5">
          <h4>
            ■ 夜間相談利用後アンケート /理解できたか
          </h4>
          <understanding-analytics
            v-model:understandingProp="ncQuestionnaireCount.understanding"
          />
        </div>
        <div class="mb-5">
          <h4>■ いつでも相談利用後アンケート / また利用したいと思うか</h4>
          <use-service-again-analytics
            v-model:useServiceAgainProp="acQuestionnaireCount.useServiceAgain"
          />
        </div>
        <div class="mb-5">
          <h4>■ いつでも相談利用後アンケート /理解できたか</h4>
          <understanding-analytics
            v-model:understandingProp="acQuestionnaireCount.understanding"
          />
        </div>
        <div class="mb-5">
          <h4>■ 日中助産師相談利用後アンケート / また利用したいと思うか</h4>
          <use-service-again-analytics
            v-model:useServiceAgainProp="daQuestionnaireCount.useServiceAgain"
          />
        </div>
        <div class="mb-5">
          <h4>■ 日中助産師相談利用後アンケート /理解できたか</h4>
          <understanding-analytics
            v-model:understandingProp="daQuestionnaireCount.understanding"
          />
        </div>
      </template>
    </div>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from "vue"
import { useStore } from "../stores/index"
import monthPicker from "./shared/MonthPicker.vue"
import useServiceAgainAnalytics from "./shared/UseServiceAgainAnalytics.vue"
import understandingAnalytics from "./shared/UnderstandingAnalytics.vue"

export default defineComponent({
  name: "QuestionnaireAnalyticsPage",
  components: {
    monthPicker,
    useServiceAgainAnalytics,
    understandingAnalytics
  },
  setup() {
    const store = useStore()

    const acQuestionnaireCount = computed(() => store.getters.anytimeConsultationQuestionnaireCount)
    const ncQuestionnaireCount = computed(() => store.getters.nightConsultationQuestionnaireCount)
    const daQuestionnaireCount = computed(() => store.getters.daytimeAdviceQuestionnaireCount)
    const selectedDate = computed(() => new Date(store.getters.selectedQuestionnaireAnalyticsDate))

    const saveSelectedDate = async (selectedValue: Date) => {
      await store.dispatch("commitSelectedQuestionnaireAnalyticsDate", selectedValue)
    }

    onMounted(() => {
      store.dispatch("commitSelectedQuestionnaireAnalyticsDate", selectedDate.value)
    })

    return {
      selectedDate,
      saveSelectedDate,
      acQuestionnaireCount,
      ncQuestionnaireCount,
      daQuestionnaireCount
    }
  },
})
</script>
